import { render, staticRenderFns } from "./AlignedSubjects.vue?vue&type=template&id=5a9fbc0e&scoped=true&lang=pug&"
import script from "./AlignedSubjects.vue?vue&type=script&lang=ts&"
export * from "./AlignedSubjects.vue?vue&type=script&lang=ts&"
import style0 from "./AlignedSubjects.vue?vue&type=style&index=0&id=5a9fbc0e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9fbc0e",
  null
  
)

export default component.exports